import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
    Grid,
    Divider,
    Message,
    Checkbox,
    Button,
    List
} from 'semantic-ui-react';

import {
    PDPA_STATEMENT,
} from '../../../constants';

import ReCAPTCHA from "react-google-recaptcha";
class ClaimSubmissionConfirm extends Component {
    state = {
        agreeToTerms: false,
        isSubmitting: false,
        hasSubmitted: false,
        isSuccess: false,
        errorMessage: null,
        message:null,
        errorTitle: '',
        robot_token: ''
    }
    handleAgreeChange = () => {
        this.setState({ agreeToTerms: !this.state.agreeToTerms })
    }
    submitClaimForm = () => {
        // console.log('submit claim form now!');
        var response = window.grecaptcha.getResponse();
        console.log("response ", response)
        this.setState({isSubmitting: true, hasSubmitted: false, isSuccess: false, errorMessage: null});
        if(response == ''){
            this.setState({isSubmitting: false, hasSubmitted: false, isSuccess: false, errorTitle: "Invalid Captcha", errorMessage: "Please verify your captcha"});
        }else{
            if (this.props.claimType === 'outpatient') {
                // submit outpatient claim
                this.props.submitOutpatientClaim(this.props.claimData, response, (result, error) => {
                    if (error) {
                        console.log('done-failed');
                        this.setState({isSubmitting: false, hasSubmitted: true, isSuccess: false, errorMessage: error.message});
                    }
                    if (result) {
                        console.log('done-success');
                        console.log('done-success-result', result);
                        this.setState({
                            isSubmitting: false,
                            hasSubmitted: true,
                            isSuccess: true,
                            errorMessage: null,
                            transactionNo: result.outpatientclaim.transactionNo,
                            claimId: result.outpatientclaim._id,
                            processClaimError: result.outpatientclaim.error,
                            message:result.message
                        });
                    }
                });
            } else if (this.props.claimType === 'inpatient') {
                // submit inpatient claim
                this.props.submitInpatientClaim(this.props.claimData, response, (result, error) => {
                    if (error) {
                        console.log('done-failed');
                        this.setState({isSubmitting: false, hasSubmitted: true, isSuccess: false, errorMessage: error.message});
                    }
                    if (result) {
                        console.log('done-success');
                        console.log('done-success-result', result);
                        this.setState({
                            isSubmitting: true,
                            hasSubmitted: true,
                            isSuccess: true,
                            errorMessage: null,
                            transactionNo: result.inpatientclaim.transactionNo,
                            claimId: result.inpatientclaim._id,
                            processClaimError: result.inpatientclaim.error,
                            message:result.message
                        });
                    }
                });
            }
        }
        
    }
    
    renderFormSubmissionResult() {
        if(this.state.errorTitle && this.state.errorTitle == "Invalid Captcha"){
            return (
                <Message negative>
                    <Message.Header>Captcha not Complete</Message.Header>
                    <p>
                        Please ensure the captha is done before proceeding.
                        <br/>
                    </p>
                </Message>
            );
        }
    }

    renderClaimSubmissionResult() {
        if (this.state.hasSubmitted === true && this.state.isSuccess === true) {
            if (this.props.claimType === 'outpatient'){
                if(this.state.transactionNo){
                    return (
                        <Message positive>
                            <p>
                                {this.state.message}
                            </p>
                            <p>
                                Please tap on <span><Link to={`/app/askjoey?type=outclaim&id=${this.state.transactionNo}`}>Ask Joey</Link></span> if you have any questions on the claim.
                            </p>
                            <p>
                                <Link to="/app/claimrecords">
                                    <Button>
                                        Back to eClaims
                                    </Button>
                                </Link>
                            </p>
                        </Message>
                    )
                }else{
                    return (
                        <Message positive>
                            <p>
                                 {this.state.message}
                            </p>
                            <p>
                                Please tap on <span><Link to={`/app/askjoey?type=outclaim&id=${this.state.claimId}`}>Ask Joey</Link></span> if you have any questions on the claim.
                            </p>
                            <p>
                                <Link to="/app/claimrecords">
                                    <Button>
                                        Back to eClaims
                                    </Button>
                                </Link>
                            </p>
                        </Message>
                    )                    
                }
                
            }

            if (this.props.claimType === 'inpatient'){
                if(this.state.transactionNo){
                    return (
                        <Message positive>
                            <p>
                                {this.state.message}
                            </p>
                            <p>
                                Please tap on <span><Link to={`/app/askjoey?type=inpclaim&id=${this.state.transactionNo}`}>Ask Joey</Link></span> if you have any questions on the claim.
                            </p>
                            <p>
                                <Link to="/app/claimrecords">
                                    <Button>
                                        Back to eClaims
                                    </Button>
                                </Link>
                            </p>
                        </Message>
                    )
                }else{
                    return (
                        <Message positive>
                            <p>
                                 {this.state.message}
                            </p>
                            <p>
                                Please tap on <span><Link to={`/app/askjoey?type=outclaim&id=${this.state.claimId}`}>Ask Joey</Link></span> if you have any questions on the claim.
                            </p>
                            <p>
                                <Link to="/app/claimrecords">
                                    <Button>
                                        Back to eClaims
                                    </Button>
                                </Link>
                            </p>
                        </Message>
                    )
                }
                
            }
        }
        if (this.state.hasSubmitted === true && this.state.isSuccess === false) {
            return (
                <Message negative>
                    <Message.Header>We're sorry - there was an issue with the claim</Message.Header>
                    <p>
                        { this.state.errorMessage }
                    </p>
                </Message>
            );
        }
    }
    render() {
        const typeOfClaimText = (this.props.claimType === 'outpatient') ? 'Outpatient' : 'Inpatient';
        return (
            <div>
                {
                    this.state.hasSubmitted === true
                    &&
                    this.state.isSuccess === true
                    &&
                    this.renderClaimSubmissionResult()
                }
                {

                    !this.state.hasSubmitted === true
                    &&
                    !this.state.isSuccess === true
                    &&
                    <Grid container columns={2}>
                        <Grid.Column width={16}>
                            <Divider horizontal>
                                Confirm Claim Submission
                            </Divider>
                        </Grid.Column>
                        <Grid.Column width={16}>
                            <Message warning>
                                <Message.Content>
                                    <p>
                                        By providing the information and submitting this application or transaction, I/we consent and agree to Income Insurance Limited (“Income”), its representatives, agents, relevant third parties, Income’s appointed insurance intermediaries and their respective third party service providers and representatives (collectively “Income Parties”) (referred to in Income's Privacy Policy at <a href={this.props.appLaunch && this.props.appLaunch.appLaunchExtra && this.props.appLaunch.appLaunchExtra.production_url_pdpa ? this.props.appLaunch.appLaunchExtra.production_url_pdpa : PDPA_STATEMENT} target="_blank">http://www.income.com.sg/privacy-policy</a>) to collect, use, and disclose any personal data in this form or obtained from other sources, including existing personal data provided and any future updates, (collectively “personal data”) for the purposes of processing and administering my/our insurance application or transaction, managing my/our relationship and policies with Income including providing me/us with financial advice/ financial planning services, sending me/us corporate communication and information on products and/or services related to my/our ongoing relationship with Income, conducting consumer profiling/data analytic/research, which includes data matching based on personal data collected by Income, its affiliates, business partners and/ or NTUC Enterprise group of social enterprises (“NE Group”) where required for Income, its affiliates, business partners and/or NE Group, to develop, improve and/ or customise their products/ services and/ or to provide you with their respective products /services, and in the manner and for other purposes described in Income's Privacy Policy.
                                    </p>
                                    <p>
                                        Where the personal data of another person(s) (for example, personal data of my family, employee, payee/payer or beneficiary) is provided by me/us or from other sources to Income Parties, I/we represent and warrant that:
                                    </p>
                                    <ul>
                                        <li>
                                            I/we have obtained their consent for the collection, disclosure and use of their personal data; and
                                        </li>
                                        <li>
                                            I am/we are authorised to give any authorisation, approval and consent on their behalf to collect, use or disclose, their personal data, for the purposes as set out in this Personal Data Use Statement.
                                        </li>
                                    </ul>
                                        For the purpose of this application and any claim in connection with my/our policy(ies) with Income, I/we also authorise, agree and consent to (whether this application or transaction is accepted or refused) the following:
                                    <List as='ol'>
                                        <List.Item as='li' value='a)'>
                                            The medical source, insurance office, reinsurer, or organisation to release to Income any medical or relevant information to do with me or the insured;
                                        </List.Item>
                                        <List.Item as='li' value='b)'>
                                            Income to collect from and/or disclose to any medical source, insurance office, reinsurer, or organisation any medical or relevant information to do with me or the insured; and
                                        </List.Item>
                                        <List.Item as='li' value='c)'>
                                            Income or any of its approved medical examiners or laboratories to perform the necessary medical assessment and tests for Income to underwrite and evaluate me or the insured health status or condition in relation to this application and any claim in connection with my/our policy(ies) with Income.
                                        </List.Item>
                                    </List>
                                    When submitting a claim for an insurance policy, I/we consent and agree that the personal data will also include any subsequent information collected on health or any information that is necessary for Income to decide whether to pay the claim, such as test results, medical examination results, and health records from medical sources such as medical examiners or laboratories.
                                    <br />I/We authorise, consent and agree to the following:
                                    <ul>
                                        <li>
                                            Income Parties to collect from and/or disclose to the group policyholder, the personal data for all the relevant purposes listed above and in Income's Privacy Policy including to respond to enquiries from the group policyholder for the purposes of this application and policy servicing matters, including confirmation of eligibility for the cover; and
                                        </li>
                                        <li>
                                            The group policyholder to disclose the personal data to Income Parties for all the relevant purposes listed above and in Income's Privacy Policy.
                                        </li>
                                    </ul>
                                    Please refer to Income's Privacy Policy for more information, including access and correction of my personal data and consent withdrawal.
                                </Message.Content>
                            </Message>
                        </Grid.Column>
                        <Grid.Column width={16}>
                            <Checkbox
                                label='I agree '
                                onChange={this.handleAgreeChange}
                                checked={this.state.agreeToTerms}
                            />
                        </Grid.Column>

                        <ReCAPTCHA 
                                    sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY}
                                    onChange={(value) => {
                                        if(value){
                                            this.setState({
                                                robot_token: value
                                            })
                                        }
                                    }}
                                />
                        {
                                this.renderFormSubmissionResult()
                            }
                        <Grid.Column width={16}>
                            <Button
                                disabled={(this.state.hasSubmitted === true) ? this.state.isSuccess : (this.state.isSubmitting === true) ? true : !this.state.agreeToTerms}
                                loading={this.state.isSubmitting}
                                fluid
                                primary
                                onClick={this.submitClaimForm}
                                size="big"
                            >
                                Submit {typeOfClaimText} Claim
                            </Button>
                        </Grid.Column>
                        
                    </Grid>
                }
            </div>
        );
    }
}

export default ClaimSubmissionConfirm
